import React from "react";
import styled from "styled-components";
import UserInfo from "../../commons/users/UserInfo";
import { BlackTheme } from "../../commons/theme_color";
import Section from "../../commons/Section";
import MyInfo from "./MyInfo";
import ComissionRule from "./ComissionRule";
import Metric from "./Metric";
import BalanceLog from "./BalanceLog";

const UnnamedComponent = (props) => (
  <React.Fragment>
    <UserInfo />
    <BlackTheme>
      <Section>
        <AffHeader style={{ "--hovered-text-color": "#f05606de" }}>
          <div />
          <div>
            <ComissionRule />
          </div>
        </AffHeader>
        <Metric>
          <MyInfo />
        </Metric>
      </Section>
      <BalanceLog />
    </BlackTheme>
  </React.Fragment>
);
export default UnnamedComponent;

const AffHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
`;
